import styled from 'styled-components';
import { PACKAGE_THEME_COLORS, PackageThemeKey } from 'features/cashier/services/package-theme';

/** Thẻ gói của khách: cùng khung với thanh StampReward ngay phía trên; chữ lớn hơn 20% theo yêu cầu để đọc được ở quầy */
export const PackageCardStyled = styled.div<{ themeKey: PackageThemeKey }>`
  display: flex;
  align-items: center;
  gap: 14px;
  /* StampReward là <button> nên mặc định border-box; thẻ này là <div>, thiếu dòng này padding sẽ cộng thêm vào width và tràn ngang */
  box-sizing: border-box;
  align-self: stretch;
  width: calc(100% - 32px);
  min-width: 0;
  min-height: 58px;
  margin: 0 16px 0.5rem;
  padding: 6px 14px;
  border-radius: 16px;
  background: ${({ themeKey }) => PACKAGE_THEME_COLORS[themeKey].main};
  color: ${({ themeKey }) => PACKAGE_THEME_COLORS[themeKey].contrastText};
  font-family: Poppins;
  cursor: pointer;

  .package-icon {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    flex-shrink: 0;

    img {
      width: 32px;
      height: 32px;
    }
  }

  .tier-badge {
    padding: 0 10px;
    border-radius: 999px;
    background: #FFFFFF;
    color: ${({ themeKey }) => PACKAGE_THEME_COLORS[themeKey].main};
    font-size: 0.96rem;
    font-weight: 600;
    line-height: 1.4;
  }

  .divider {
    flex-shrink: 0;
    width: 1px;
    align-self: stretch;
    margin: 6px 0;
    background: rgba(255, 255, 255, 0.4);
  }

  .package-info {
    display: flex;
    flex-direction: column;
    min-width: 0;
    flex: 1;
  }

  .program-name {
    font-size: 1.44rem;
    font-weight: 700;
    line-height: 1.25;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .expires {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 1.08rem;
    line-height: 1.25;
    opacity: 0.9;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .sessions {
    flex-shrink: 0;
    font-size: 1.2rem;
    line-height: 1.25;
    white-space: nowrap;

    strong {
      font-size: 1.68rem;
      font-weight: 800;
    }
  }
`;

export const PackagePopoverList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 520px;
  max-width: 90vw;

  /* trong popover thẻ chiếm trọn bề ngang, bỏ margin dành cho cột ticket */
  ${PackageCardStyled} {
    width: 100%;
    margin: 0;
  }
`;
